module.exports = __webpack_public_path__ + "img/continue_right.2e1dac1f.svg";